<template>
  <div class="c2c-langpicker">
    <label for="lang-select" class="c2c-langpicker-label">
      {{ t("app.language") }}
    </label>
    <select
      id="lang-select"
      :value="currentLang"
      @change="onChange"
      class="c2c-langpicker-select"
      :aria-label="t('app.language')"
    >
      <option v-for="l in SUPPORTED_LANGUAGES" :key="l.code" :value="l.code">
        {{ l.native }}
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { SUPPORTED_LANGUAGES, setLanguage, type LangCode } from "@/i18n"

const { t, locale } = useI18n()
const currentLang = computed(() => locale.value)

function onChange(e: Event) {
  const target = e.target as HTMLSelectElement
  setLanguage(target.value as LangCode)
}
</script>

<style scoped>
.c2c-langpicker {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.c2c-langpicker-label {
  font-size: 12px;
  color: #54595d;
}
.c2c-langpicker-select {
  background: white;
  border: 1px solid #a2a9b1;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  max-width: 140px;
}
.c2c-langpicker-select:hover {
  border-color: #3366cc;
}
.c2c-langpicker-select:focus {
  outline: 2px solid #3366cc;
  outline-offset: -2px;
  border-color: #3366cc;
}
@media (max-width: 540px) {
  .c2c-langpicker-label { display: none; }
}
</style>
